import { EmailEventStatus } from '@/__generated__/graphql';

export const allocationHistoryTableColumns = [
  { title: 'Investor Entity', key: 'legalEntity', width: 450, keySort: 'investor entity', isFixed: true },
  { title: 'Strategy', key: 'investment', width: 300, keySort: 'strategy' },
  { title: 'Status Date', key: 'statusDate', width: 250, keySort: 'status date' },
  { title: 'Status', key: 'allocationStatus', width: 250, keySort: 'allocation status' },
  { title: 'Details', key: null, keySort: 'details', width: 250 },
  { title: 'Advisory Firm', key: 'advisoryFirm', width: 250, keySort: 'advisory firms' },
  { title: ' ', key: ' ', width: 50 }
];

export const dueDiligenceHistoryTableColumns = [
  { title: 'Strategy', key: 'strategy', width: 450, keySort: 'strategy', isFixed: true },
  { title: 'Asset Class', key: 'assetClass', width: 300, keySort: 'asset class' },
  { title: 'Status', key: 'status', width: 250, keySort: 'status' },
  { title: 'Tier', key: 'tier', width: 250, keySort: 'tier' },
  { title: 'Decision Maker', key: 'approver', width: 250, keySort: 'investment' },
  { title: 'Status Date', key: 'statusUpdatedAt', width: 250, keySort: 'status date' },
  { title: ' ', key: ' ', width: 50 }
];

export const dealDocumentsTrackingTableColumns = [
  { title: 'Investor Entity', key: 'legalEntityName', width: 450, keySort: 'investor entity', isFixed: true },
  { title: 'Strategy', key: 'investmentName', width: 300, keySort: 'strategy' },
  { title: 'Action', key: 'action', width: 250, keySort: 'action' },
  { title: 'Action Date', key: 'actionDate', width: 250, keySort: 'action date' },
  { title: 'User', key: 'actionPerformedBy', keySort: 'user', width: 250 },
  { title: 'Recipient', key: 'emailRecipient', keySort: 'recipient', width: 250 },
  { title: 'Docs Sent', key: null, keySort: 'docs sent', width: 250 },
  { title: 'Email Tracking', key: 'emailTrackingStatus', width: 250, keySort: 'email tracking' },
  { title: 'Transaction Status', key: 'operationsWorkflowTransitionTask', width: 250, keySort: 'transaction status' },
  { title: 'Status Date', key: 'lastUpdatedAt', width: 250, keySort: 'status date' },
  { title: 'Advisory Firm', key: 'tenantName', width: 250, keySort: 'advisory firms' }
];

export const dealDocumentsTrackingTableEmailTrackingCellTooltips = {
  [EmailEventStatus.Sent]: 'This email was sent to the email address.',
  [EmailEventStatus.Delivered]: 'The recipient’s email client verified receipt of this email.',
  [EmailEventStatus.Opened]: 'The recipient opened this email.',
  [EmailEventStatus.ManuallyLogged]:
    'The user manually indicated that documentation was sent to the investor. No confirmation or tracking is available.',
  [EmailEventStatus.DeliveryFailed]: '',
  [EmailEventStatus.Pending]: '',
  [EmailEventStatus.PendingDelivery]: '',
  [EmailEventStatus.RetryingDelivery]: '',
  [EmailEventStatus.Unknown]: ''
};

export const allocationHistoryMobileTableSort = [
  {
    title: 'Investor Entity • A -> Z',
    key: 'legalEntity',
    asc: true
  },
  {
    title: 'Investor Entity • Z -> A',
    key: 'legalEntity',
    asc: false
  },
  {
    title: 'Strategy • A -> Z',
    key: 'investment',
    asc: true
  },
  {
    title: 'Strategy • Z -> A',
    key: 'investment',
    asc: false
  },
  {
    title: 'Status Date • Newest -> Oldest',
    key: 'statusDate',
    asc: true
  },
  {
    title: 'Status Date • Oldest -> Newest',
    key: 'statusDate',
    asc: false
  },
  {
    title: 'Status • Earlier statuses -> Later statuses',
    key: 'allocationStatus',
    asc: true
  },
  {
    title: 'Status • Later statuses -> Earlier statuses',
    key: 'allocationStatus',
    asc: false
  },
  {
    title: 'Advisory Firm • A -> Z',
    key: 'advisoryFirm',
    asc: true
  },
  {
    title: 'Advisory Firm • Z -> A',
    key: 'advisoryFirm',
    asc: false
  }
];

export const dueDiligenceHistoryMobileTableSort = [
  {
    title: 'Strategy • A -> Z',
    key: 'strategy',
    asc: true
  },
  {
    title: 'Strategy • Z -> A',
    key: 'strategy',
    asc: false
  },
  {
    title: 'Asset Class • A -> Z',
    key: 'assetClass',
    asc: true
  },
  {
    title: 'Asset Class • Z -> A',
    key: 'assetClass',
    asc: false
  },
  {
    title: 'Status • Approved -> Rejected',
    key: 'status',
    asc: true
  },
  {
    title: 'Status • Rejected -> Approved',
    key: 'status',
    asc: false
  },
  {
    title: 'Tier • Newest -> Oldest',
    key: 'tier',
    asc: true
  },
  {
    title: 'Tier • Oldest -> Newest',
    key: 'tier',
    asc: false
  },
  {
    title: 'Decision Maker • A -> Z',
    key: 'approver',
    asc: false
  },
  {
    title: 'Decision Maker • Z -> A',
    key: 'approver',
    asc: true
  },
  {
    title: 'Status Date • Newest -> Oldest',
    key: 'statusUpdatedAt',
    asc: false
  },
  {
    title: 'Status Date • Oldest -> Newest',
    key: 'statusUpdatedAt',
    asc: true
  }
];

export const dealDocumentsTrackingMobileTableSort = [
  {
    title: 'Investor Entity • A -> Z',
    key: 'legalEntityName',
    asc: true
  },
  {
    title: 'Investor Entity • Z -> A',
    key: 'legalEntityName',
    asc: false
  },
  {
    title: 'Strategy • A -> Z',
    key: 'investmentName',
    asc: true
  },
  {
    title: 'Strategy • Z -> A',
    key: 'investmentName',
    asc: false
  },
  {
    title: 'Action • A -> Z',
    key: 'action',
    asc: true
  },
  {
    title: 'Action • Z -> A',
    key: 'action',
    asc: false
  },
  {
    title: 'Action Date • Newest -> Oldest',
    key: 'actionDate',
    asc: true
  },
  {
    title: 'Action Date • Oldest -> Newest',
    key: 'actionDate',
    asc: false
  },
  {
    title: 'User • A -> Z',
    key: 'actionPerformedBy',
    asc: true
  },
  {
    title: 'User • Z -> A',
    key: 'actionPerformedBy',
    asc: false
  },
  {
    title: 'Recipient • A -> Z',
    key: 'emailRecipient',
    asc: true
  },
  {
    title: 'Recipient • Z -> A',
    key: 'emailRecipient',
    asc: false
  },
  {
    title: 'Email Tracking • A -> Z',
    key: 'emailTrackingStatus',
    asc: true
  },
  {
    title: 'Email Tracking • Z -> A',
    key: 'emailTrackingStatus',
    asc: false
  },
  {
    title: 'Transaction Status • A -> Z',
    key: 'operationsWorkflowTransitionTask',
    asc: true
  },
  {
    title: 'Transaction Status • Z -> A',
    key: 'operationsWorkflowTransitionTask',
    asc: false
  },
  {
    title: 'Status Date • Newest -> Oldest',
    key: 'lastUpdatedAt',
    asc: true
  },
  {
    title: 'Status Date • Oldest -> Newest',
    key: 'lastUpdatedAt',
    asc: false
  },
  {
    title: 'Advisory Firm • A -> Z',
    key: 'tenantName',
    asc: true
  },
  {
    title: 'Advisory Firm • Z -> A',
    key: 'tenantName',
    asc: false
  }
];
